import { render } from "./Machinery.vue?vue&type=template&id=42aab32c&scoped=true"
import script from "./Machinery.vue?vue&type=script&lang=js"
export * from "./Machinery.vue?vue&type=script&lang=js"

import "./Machinery.vue?vue&type=style&index=0&id=42aab32c&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\Administrator\\betaver_webpage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42aab32c"]])

export default __exports__